@if (!utils.isCollectionNullOrEmpty(cmcdPlcList)) {
<div @triggerPeriode>


  <!--    GRILLE DES EFFECTIFS-->

  <p-table
    [scrollHeight]="utils.scrollHeightContent(230)"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [value]="rows">

    <!--CAPTION-->
    <ng-template pTemplate="caption">
      <div class="d-flex justify-content-between">

        <div class="font-12">
          <i class="fas fa-map-pin mg-r-5 pn-border-color"></i>
          <span class="mg-r-5">
                {{ pointDeLivraison.libelle | uppercase }}
            - <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(cmcMnSvc.getPeriodeLabelHTML(periode))"></span>
              </span>
          <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
        </div>

        <div>
          <span class="mg-r-5">
            <p-menu appendTo="body" #editPlanning [popup]="true" [model]="itemsEditPlanning"></p-menu>
            <yo-button
              iconClass="fas fa-edit"
              [theme]="ButtonThemeEnum.DEFAULT"
              class="mg-r-5"
              (onClick)="editPlanning.toggle($event)"
              tooltip="Modification en masse des  effectifs, coûts et taux de prise théoriques">
            </yo-button>
          </span>
          <span class="mg-r-5">
            <yo-button
              tooltip="Enregistrer"
              type="submit"
              iconClass="fas fa-save"
              [theme]="ButtonThemeEnum.SUCCESS"
              (onClick)="savePlanning()"
              [disabled]="!gds.canModify(contratMenuConvive)"></yo-button>
          </span>
        </div>

      </div>
    </ng-template>

    <!--HEADER-->
    <ng-template pTemplate="header">

      <tr>
        <th pFrozenColumn [style.width.px]="colRepasWidth" [style.min-width.px]="colRepasWidth">Jour</th>
        <th pFrozenColumn [style.width.px]="colRepasWidth" [style.min-width.px]="colRepasWidth">Repas</th>
        <th pFrozenColumn [style.width.px]="colRepasWidth" [style.min-width.px]="colRepasWidth">Régime</th>
        <th pFrozenColumn [style.width.px]="colRepasWidth" [style.min-width.px]="colRepasWidth" title="Effectif prévisionnel">
          Effectif prév.
        </th>
        <th pFrozenColumn [style.width.px]="colRepasWidth" [style.min-width.px]="colRepasWidth" title="Coût prévisionnel">
          Coût prév.
        </th>

        @for (col of cols; track utils.trackByFn($index,col)) {
        <ng-container>
          <th [style.width.px]="cellWidth" [style.min-width.px]="cellWidth">
            <div class="no-overflow" [title]="col.libelle">
              {{ col.libelle | uppercase }}
            </div>

          </th>
        </ng-container>
        }
      </tr>
    </ng-template>

    <!--BODY-->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td pFrozenColumn
            [class.jour-cell-start]="rowGroupMetadata[rowData.idJourSemaine].index === rowIndex"
            [class.jour-cell-continue]="rowGroupMetadata[rowData.idJourSemaine].index !== rowIndex"
            [style.width.px]="colRepasWidth"
            [style.min-width.px]="colRepasWidth">
          <div class="no-overflow jour-cell-content">
            @if (rowGroupMetadata[rowData.idJourSemaine].index === rowIndex) {
              <strong>{{ utils.getJourSemaineById(rowData.idJourSemaine).viewValue | uppercase }}</strong>
            }
          </div>
        </td>

        <td pFrozenColumn
            [style.width.px]="colRepasWidth"
            [style.min-width.px]="colRepasWidth"
            [style.height.px]="getTailleComposante(rowData)"
            [style.vertical-align]="'middle'">
          <div class="no-overflow" [title]="rowData.repasLibelle">
            <strong>{{ rowData.repasLibelle }}</strong>
          </div>
        </td>

        <td
            [style.width]="'100%'"
            [style.height.px]="getTailleComposante(rowData)"
            [style.vertical-align]="'middle'">
          <ng-container *ngTemplateOutlet="tplRegime;context:{list:getAllCmcrCmcCaPlc(rowData)}"></ng-container>
        </td>

        <td pFrozenColumn
            [style.width.px]="colRepasWidth"
            [style.min-width.px]="colRepasWidth"
            [style.height.px]="getTailleComposante(rowData)"
            [style.vertical-align]="'middle'">
          <ng-container *ngTemplateOutlet="tplEffectifPrev;context:{list:getAllCmcrCmcCaPlc(rowData)}"></ng-container>
        </td>

        <td pFrozenColumn
            [style.width.px]="colRepasWidth"
            [style.min-width.px]="colRepasWidth"
            [style.height.px]="getTailleComposante(rowData)"
            [style.vertical-align]="'middle'">
          <ng-container *ngTemplateOutlet="tplCoutPrev;context:{list:getAllCmcrCmcCaPlc(rowData)}"></ng-container>
        </td>

        <!--CELLULES-->
        @for (col of cols; track utils.trackByFn($index,col)) {
        <ng-container>
          <ng-container *ngTemplateOutlet="tplCell;context:{cmcr:rowData,cell:getCell(rowData,col)}">
          </ng-container>
        </ng-container>
        }

      </tr>

    </ng-template>

  </p-table>

</div>
}


<!--TEMPLATE CELLULE-->
<ng-template #tplCell let-cell="cell" let-cmcr="cmcr">
  <td [style.width.px]="cellWidth" style="text-align: right;"
      [style.height.px]="getTailleComposante(cmcr)"
      [style.vertical-align]="'top'">


    @for (_ of utils.getSlots(cell.nombreChoixMaximum); track $index) {
      <ng-container
        *ngTemplateOutlet="tplCmcdPlc;context:{cmcdPlc:getCmcdPlc(cell, $index+1)}">
      </ng-container>
    }


  </td>
</ng-template>

<!--TEMPLATE contrat_menu_convive_decoupage__plc INPUT CELL (saisie de l'effectif previsionnel en % pour un jour/repas/decoupage/plat)-->
<ng-template #tplCmcdPlc let-cmcdPlc="cmcdPlc">

  @if (!utils.isNullOrEmpty(cmcdPlc)) {
    <div class="input-group input-group-sm mg-t-5">
      <div class="input-group-prepend ">
        <span class="input-group-text font-10">Plat {{ cmcdPlc.ordre }}</span>
      </div>
      <input type="text" [style.max-width.px]="50" style="text-align: right;"
             placeholder=""
             title="Taux de prise"

             (keydown)="utils.keydownNumber($event,cmcdPlc,'tauxDePrise',true)"
             [(ngModel)]="cmcdPlc.tauxDePrise"
             pKeyFilter="pint">

      <div class="input-group-append">
          <span class="input-group-text font-10">%
          </span>
      </div>

      @if (cmcdPlc.arrondiEffPrev) {
        <i class="fas fa-exclamation-triangle danger-color cursor mg-l-5 mg-t-5"
           title="Arrondi réalisé pour que la somme des plats corresponde à l'effectif prévisionnel du jour / repas ."
        ></i>
      }

    </div>
  }


</ng-template>

<!--TEMPLATE REGIME -->
<ng-template #tplRegime let-list="list">
  @for (item of list; track item) {
    <div class="mg-t-8 regime-cell" [title]="item.libelleRegime">
      <strong>{{ item.libelleRegime }}</strong>
    </div>
  }
</ng-template>

<!--TEMPLATE EFFECTIF PREVISIONNEL -->
<ng-template #tplEffectifPrev let-list="list">
  @for (item of list; track item) {
  <div class="input-group input-group-sm mg-t-5">
    <input type="text" [style.max-width.px]="50" style="text-align: right;"
           placeholder=""
           (keydown)="utils.keydownNumber($event, item,'effectifPrevisionnel',true)"
           [(ngModel)]="item.effectifPrevisionnel"
           pKeyFilter="pint">
    <div class="input-group-append">
      <span class="input-group-text font-10">pers.
      </span>
    </div>
  </div>
  }
</ng-template>

<!--TEMPLATE COUT PREVISIONNEL -->
<ng-template #tplCoutPrev let-list="list">
  @for (item of list; track item) {
  <div class="input-group input-group-sm mg-t-5">
    <input type="text" [style.max-width.px]="50" style="text-align: right;"
           placeholder=""
           (keydown)="utils.keydownNumber($event,item,'coutPrevisionnel',true)"
           [(ngModel)]="item.coutPrevisionnel"
           pKeyFilter="pint">

    <div class="input-group-append">
      <span class="input-group-text font-10">€
      </span>
    </div>
  </div>
  }
</ng-template>


<!--DIALOG EFFECTIFS PREV-->
<yo-dialog-update-effectifs
  [(visible)]="displayEffectifDialog"
  mode="effectif"
  [repasList]="repasList"
  [joursSemaine]="joursSemaine"
  [cmcrCmcCaPlcList]="cmcrCmcCaPlcList"
></yo-dialog-update-effectifs>

<!--DIALOG COUT THEORIQUE-->
<yo-dialog-update-effectifs
  [(visible)]="displayCoutDialog"
  mode="cout"
  [repasList]="repasList"
  [joursSemaine]="joursSemaine"
  [cmcrCmcCaPlcList]="cmcrCmcCaPlcList"
></yo-dialog-update-effectifs>

<!--DIALOG TAUX DE PRISE PREV-->
<yo-dialog-update-taux-prise
  [(visible)]="displayTauxDePriseDialog"
  [joursSemaine]="joursSemaine"
  [repasList]="repasList"
  [decoupageRepasList]="decoupageRepasList"
  [platList]="platList"
  [rows]="rows"
  [cells]="cells"
  [cmcdPlcList]="cmcdPlcList"
></yo-dialog-update-taux-prise>

